const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

const getApiBaseUrl = () => {
  const configuredUrl = (process.env.REACT_APP_SERVER_URL || '').trim();

  if (!configuredUrl || typeof window === 'undefined') {
    return configuredUrl.replace(/\/$/, '');
  }

  try {
    const configuredHost = new URL(configuredUrl, window.location.origin).hostname;
    const currentHost = window.location.hostname;

    if (!LOCAL_HOSTS.has(currentHost) && LOCAL_HOSTS.has(configuredHost)) {
      return '';
    }
  } catch (error) {
    console.error('API 주소 해석 실패:', error);
  }

  return configuredUrl.replace(/\/$/, '');
};

export default getApiBaseUrl;